var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('td',{staticClass:"articles-table__add-button",class:{ 'articles-table__add-button--added': _vm.added },on:{"click":_vm.emitClick}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c('hr'),_c('hr')])
}]

export { render, staticRenderFns }